import { Component, OnInit, Input } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { ApiUrl } from 'src/app/services/apiUrl';

@Component({
  selector: 'app-store-opening-hours',
  templateUrl: './store-opening-hours.component.html',
  styleUrls: ['./store-opening-hours.component.scss'],
})
export class StoreOpeningHoursComponent implements OnInit {
  @Input() id: any;
  holidays: any;
  savedHolidays: any;
  holidayCount: any;
  storeId: any;
  selectedHolidayId: any;

  storeTimings = {
    normal: {
      monday: { open: '', close: '', closed: false },
      tuesday: { open: '', close: '', closed: false },
      wednesday: { open: '', close: '', closed: false },
      thursday: { open: '', close: '', closed: false },
      friday: { open: '', close: '', closed: false },
      saturday: { open: '', close: '', closed: false },
      sunday: { open: '', close: '', closed: false },
    },
    holiday: [
      {
        holidayId: null,
        storeId: '',
        date: '',
        open: '',
        close: '',
        closed: false,
      },
    ],
  };

  // selectedHolidayDate: any;

  constructor(
    private dialogRef: NbDialogRef<StoreOpeningHoursComponent>,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private route: Router,
    private service: ApiService
  ) {}

  ngOnInit() {
    if (this.holidays && this.holidays.length > 0) {
      this.holidays.holidayId = this.holidays[0].id;
    }
    this.getTimingsById();
    this.getHolidayList();
  }

  onHolidaySelect(event: any, index: number) {
    const selectedHolidayId = event;
    // console.log(selectedHolidayId, 'selectedHolidayId');
    // console.log(this.savedHolidays, 'this.savedHolidays');

    if (
      !this.savedHolidays == undefined &&
      this.savedHolidays.includes(selectedHolidayId)
    ) {
      this.toastr.warning('This holiday is already added for this store.');
      return;
    }

    const selectedHoliday = this.holidays.find(
      (holiday: { id: any }) => holiday.id === selectedHolidayId
    );

    if (selectedHoliday) {
      const selectedDate = new Date(selectedHoliday.date);
      const formattedDate = selectedDate.toISOString().split('T')[0];

      this.storeTimings.holiday[index].date = formattedDate;
    } else {
      console.error('Holiday not found with ID:', selectedHolidayId);
    }
  }

  getHolidayList() {
    this.spinner.show();
    this.service.getRequest(ApiUrl.getHolidays).subscribe(
      (res: any) => {
        this.spinner.hide();

        if (res && res.response && res.response.data) {
          this.holidays = res.response.data.nationalHolidayList;
          this.holidayCount = res.response.data.nationalHolidayCount;
        }
      },
      (err) => {
        this.spinner.hide();
        this.toastr.error('An error occurred while fetching store timings');
      }
    );
  }

  onSave() {
    const validHolidays = this.storeTimings.holiday.filter(
      (holiday) =>
        holiday.holidayId || holiday.date || holiday.open || holiday.close
    );
    // console.log(validHolidays,"validholidays")

    const requestData: any = {
      storeId: this.id,
      normalTimings: this.storeTimings.normal,
    };

    if (validHolidays.length > 0) {
      requestData.holidaysTimings = validHolidays.map((holiday) => ({
        ...holiday,
        storeId: this.id,
      }));
    }
    this.spinner.show();

    if (!this.storeId) {
      this.service.postRequest(ApiUrl.addTimings, requestData).subscribe(
        (res: any) => {
          this.toastr.success(res.response.message);
          this.dialogRef.close();
          this.spinner.hide();
        },
        (err) => {
          this.spinner.hide();
          this.toastr.error(err.error.response.message);
        }
      );
    } else {
      this.service
        .putRequest(`${ApiUrl.updateTimings}${this.id}`, requestData)
        .subscribe(
          (res: any) => {
            this.toastr.success(res.response.message);
            this.dialogRef.close();
            this.spinner.hide();
          },
          (err) => {
            this.spinner.hide();
            this.toastr.error(err.error.response.message);
          }
        );
    }
  }

  // getTimingsById() {
  //   this.spinner.show();
  //   this.service.getRequest(`${ApiUrl.getTimings}${this.id}`).subscribe(
  //     (res: any) => {
  //       this.spinner.hide();
  //       if (res && res.response && res.response.data) {
  //         const storeTimingsData = res.response.data.storeTimingData;
  //         console.log(storeTimingsData, 'storeTimingsData');

  //         this.storeId = storeTimingsData?._id;

  //         if (storeTimingsData.normalTimings) {
  //           this.storeTimings.normal = storeTimingsData?.normalTimings;
  //         }
  //         console.log(
  //           res.response.data.holidaytimingData,
  //           'res.response.data.holidaytimingData'
  //         );
  //         if (res.response.data.holidaytimingData) {
  //           this.storeTimings.holiday = res.response.data.holidaytimingData.map(
  //             (holiday: any) => {
  //               const formattedDate = new Date(holiday.date)
  //                 .toISOString()
  //                 .split('T')[0];
  //               return {
  //                 _id: holiday._id,
  //                 holidayId: holiday.holidayId?.id || holiday.holidayId,
  //                 storeId: holiday.storeId,
  //                 date: formattedDate,
  //                 open: holiday.open || '',
  //                 close: holiday.close || '',
  //                 closed: holiday.closed || false,
  //               };
  //             }
  //           );
  //         }
  //         console.log(this.storeTimings.holiday, 'this.storeTimings.holiday');

  //         // console.log(this.storeTimings.holiday, 'holidayssss');
  //         this.savedHolidays = this.storeTimings.holiday.map(
  //           (holiday: any) => holiday.holidayId
  //         );
  //       }
  //     },
  //     (err) => {
  //       this.spinner.hide();
  //       this.toastr.error('An error occurred while fetching store timings');
  //     }
  //   );
  // }

  getTimingsById() {
    this.spinner.show();
    this.service.getRequest(`${ApiUrl.getTimings}${this.id}`).subscribe(
      (res: any) => {
        this.spinner.hide();
        if (res && res.response && res.response.data) {
          const storeTimingsData = res.response.data.storeTimingData;

          // Check if storeTimingsData is not null or undefined
          if (storeTimingsData) {
            // console.log(storeTimingsData, 'storeTimingsData');
            this.storeId = storeTimingsData._id;

            if (storeTimingsData.normalTimings) {
              this.storeTimings.normal = storeTimingsData.normalTimings;
            }

            if (res.response.data.holidaytimingData) {
              this.storeTimings.holiday =
                res.response.data.holidaytimingData.map((holiday: any) => {
                  const formattedDate = new Date(holiday.date)
                    .toISOString()
                    .split('T')[0];
                  return {
                    _id: holiday._id,
                    holidayId: holiday.holidayId?.id || holiday.holidayId,
                    storeId: holiday.storeId,
                    date: formattedDate,
                    open: holiday.open || '',
                    close: holiday.close || '',
                    closed: holiday.closed || false,
                  };
                });
            }
            // console.log(this.storeTimings.holiday, 'this.storeTimings.holiday');

            this.savedHolidays = this.storeTimings.holiday.map(
              (holiday: any) => holiday.holidayId
            );
          } else {
            console.log('No store timings data available.');
          }
        }
      },
      (err) => {
        this.spinner.hide();
        this.toastr.error('An error occurred while fetching store timings');
      }
    );
  }

  addHoliday() {
    if (this.storeTimings.holiday.length < this.holidayCount) {
      this.storeTimings.holiday.push({
        holidayId: null,
        storeId: '',
        date: '',
        open: '',
        close: '',
        closed: false,
      });
    } else {
      this.toastr.warning(
        'You cannot add more holidays than the national holiday count.'
      );
    }
  }
  removeHoliday(index: number) {
    const holidayToDelete: any = this.storeTimings.holiday[index];
    // console.log(holidayToDelete, 'holidayToDelete');
    let holidayId = holidayToDelete._id;
    if (holidayId) {
      this.service
        .deletRequest(`${ApiUrl.deleteHolidayTimings}${holidayId}`)
        .subscribe(
          (response: any) => {
            this.storeTimings.holiday.splice(index, 1);
            // this.toastr.success('Holiday deleted successfully!');
          },
          (error) => {
            console.error('Error deleting holiday:', error);
            this.toastr.error('Failed to delete holiday');
          }
        );
    } else {
      this.storeTimings.holiday.splice(index, 1);
    }
  }

  isHolidaySelected(holidayId: any): boolean {
    return this.storeTimings.holiday
      .map((holiday) => holiday.holidayId)
      .includes(holidayId);
  }

  onClose() {
    this.dialogRef.close();
  }
}
